import React from 'react';
import {
  QButton,
  QEmptyState,
  QEmptyStateButtonGroup,
  QEmptyStatePrimaryButton,
  useCurrentUser,
} from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';

export const UpsellDevApi: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { t } = useTranslation();
  const user = useCurrentUser();

  if (user.capabilities?.api) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
  }

  return (
    <QEmptyState
      data-cy="route-guard-upsell"
      title={t('emptyStates.noApiAccess.title')}
      subtitle={t('emptyStates.noApiAccess.subtitle')}
    >
      <QEmptyStateButtonGroup>
        <QEmptyStatePrimaryButton>
          <QButton variant="solid" onClick={() => window.open('mailto:upgrades@qualio.com')}>
            {t('emptyStates.noApiAccess.contactSupport')}
          </QButton>
        </QEmptyStatePrimaryButton>
      </QEmptyStateButtonGroup>
    </QEmptyState>
  );
};
